/* eslint-disable no-undef */
import { useContext, useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import StatusCard from "./components/StatusCard/StatusCard";
import UserDashboard from "./components/UserDashboard/UserDashboard";
import "./styles.css";
import { Context } from "../../hooks/useAuthContext";
import api from "../../services/axiosConfig";
import ManutencaoAlert from "./components/ManutencaoAlert/ManutencaoAlert";
import AfiliadoDashboard from "./components/AfiliadoDashboard/AfiliadoDashboard";

export default function Profile() {
  const { userData, storageUser, exibirLogs } = useContext(Context);
  const [statusAprovacao, setStatusAprovacao] = useState(
    userData?.statusAprovacao
  );
  const [motivo, setMotivo] = useState(userData?.motivoRejeicao);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    isActive: false,
  });

  useEffect(() => {
    async function getStatusUser() {
      try {
        const { statusAprovacao, motivoRejeicao } = userData || {};

        if (statusAprovacao && statusAprovacao !== status) {
          setStatusAprovacao(statusAprovacao);
        }

        if (motivoRejeicao) {
          setMotivo(motivoRejeicao);
        }

        // Atualiza no contexto/cache com tudo atualizado
        storageUser({
          ...userData,
          statusAprovacao,
          motivoRejeicao,
        });
      } catch (err) {
        exibirLogs && console.error("Erro ao buscar status:", err);
      }
    }

    getStatusUser();
  }, []);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const response = await api.get("/manutencao");
        setFormData(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchStatus();
  }, []);

  return (
    <div className="content">
      <Header urlFoto="https://i.imgur.com/nCIToeZ.png" />
      {formData && formData.isActive && (
        <ManutencaoAlert
          title={formData.title}
          message={formData.description}
        />
      )}
      <div className="wrapper">
        {statusAprovacao === "Aprovado" ? (
          <>
            {userData.idAfiliado ? <AfiliadoDashboard /> : <UserDashboard />}
            
          </>
        ) : (
          <StatusCard status={statusAprovacao} motivo={motivo} />
        )}

        <div className="logoPage">
          <img
            src="https://i.imgur.com/nCIToeZ.png"
            alt="Logo do Link do bem"
          />
        </div>

        <div style={{ marginTop: 30 }}>
          <center>
            <span style={{ color: "#777" }}>v:{__APP_VERSION__}</span>
          </center>
        </div>
      </div>
    </div>
  );
}
